import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { queries } from 'RestAPIs/rapini';
import { useColumnDefinitions } from './hooks/useColumnDefinitions';
import { useTranslation } from 'react-i18next';

const Configurations = () => {
  const columnDefinitions = useColumnDefinitions();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.configurations'
  });
  const { data, isLoading } = queries.useFindConfigurationSettings();

  return (
    <TableCRUDLayout
      rows={data}
      loading={isLoading}
      columns={columnDefinitions}
      getRowId={(row) => row.id}
      editable={false}
      confirmationTitle={t('deleteDialog.title')}
      confirmationBody={t('deleteDialog.body')}
    />
  );
};

export default Configurations;
